import defaultSorting from './default';
import timeSorting from './time';
import popularitySorting from './popularity';

export default (state) => [
  defaultSorting,
  timeSorting,
  popularitySorting,
].filter((method) => method.applicable(state));
